export class PartnersConstants {
    static readonly PARTNER = '/partner';
    static readonly PARTNERS = '/partners';
    static readonly SLASH = '/';
    static readonly SEARCH_NAME = '?partnernamesearch=';
    static readonly SORTBY = '?sortby=';
    static readonly SORT_TYPE = '&sorttype=';
    static readonly POPUP_TEXT = 'Images must be in JPG, PNG Format.';
    static readonly USERS = '/users';
    static readonly searchNamePlaceHolderText = $localize`:@@partners.data-header.search-name:Search by Partner Name...`;
    static readonly EDIT = $localize`:@@partners.edit:Edit`;
    static readonly PARTNERNAMEPLACEHOLDER = $localize`:@@partners.partner-name-placeholder:Enter Partner Name`;
    static readonly UPDATED_TIME = 'updatedTime';
    static readonly DESC = 'desc';
    static readonly PUBLISH_MESSAGE = '/publishMessage';
    static readonly PREVIOUS_MESSAGE = '/previousMessage';
    static readonly PARTNERLOGO = '/partnerLogo';
    static readonly PARTNERVIDEO = '/partnerVideo';
}